import FeatureFlag, { FeatureFlagRoleType, FeatureFlagValues } from 'data/FeatureFlag';
import  User , * as UserFunction from 'data/User';
import { BusinessUnit } from 'data/BusinessUnit';
import { GroupedUserPermissions } from 'data/UserPermissions';
import { getItems } from 'lib/SessionStorage';
import { STORAGE_KEYS } from 'constants/general';

export const grantAccess = (
    featureFlags: FeatureFlag, 
    key: FeatureFlagValues,
    user: User
) => {
  const requestedFlag = featureFlags[key];
  const isVendor = UserFunction.isVendor(user!);
  const isVendorAdmin = UserFunction.isVendorAdmin(user!);

  if (!requestedFlag) return false;
  
  const userRole =  isVendorAdmin ? ['VENDOR_ADMIN', 'VENDOR'] : isVendor ? ['VENDOR'] : ['ADMIN', 'VENDOR_ADMIN', 'VENDOR'];

  const grantAccess = requestedFlag.enabled && 
  (
    requestedFlag.role === FeatureFlagRoleType.ALL ||
    userRole.includes(requestedFlag.role)
  )
  
  return grantAccess;
};


/**
 * Returns the essential permission info
 * @param {Array} permissionsData - The array of permission groups with their data
 * @param {string} code - The permission code to search for
 * @returns {Object|null} Simplified permission object with only code, readAccess, and writeAccess
 */
export function getPermissionAccessByCode(code: string) {
  const permissionGroups = getItems(STORAGE_KEYS.PERMISSION_GROUPS) as GroupedUserPermissions[] || [];

  // Use flatMap to flatten all permission data into a single array, then find the matching code
  const permission = permissionGroups.flatMap(group => group.data)
    .find(item => item.code === code);
  
  if (!permission) return null;
  
  // Destructure only the properties we need
  const { code: permCode, readAccess, writeAccess, active } = permission;
  return { code: permCode, readAccess, writeAccess, active };
}

export function isPermissionReadOnly(
  permissionCode: string,
  user: User | null,
  selectedBusinessUnit: BusinessUnit | null | undefined,
  selectedVendorId?: number
): boolean {
  const featureFlags = getItems(STORAGE_KEYS.FEATURE_FLAGS);
  if (!featureFlags?.businessUnit?.enabled) return false;

  if (user && (UserFunction.hasOfmpAdminProfile(user) || UserFunction.isOfmpAdmin(user))) return false;

  if (selectedBusinessUnit === null && !UserFunction.hasVendorAdminProfileForVendor(user, selectedVendorId)) return true;

  const permission = getPermissionAccessByCode(permissionCode);
  return !!permission && !permission.writeAccess;
}
